import React from 'react';

function AffiliateChart({ data, type = 'bar', title }) {
  const maxValue = Math.max(...data.map(d => d.value), 1);
  
  if (type === 'bar') {
    return (
      <div className="space-y-2">
        {title && <h4 className="text-sm font-medium text-neutral-400 mb-3">{title}</h4>}
        {data.map((item, index) => (
          <div key={item.label ?? index} className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="text-neutral-300">{item.label}</span>
              <span className="font-medium text-white">{item.displayValue || item.value}</span>
            </div>
            <div className="h-2 bg-neutral-800 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{
                  width: `${(item.value / maxValue) * 100}%`,
                  backgroundColor: item.color || '#00F0FF'
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
  
  // Line chart (simplified)
  if (type === 'line') {
    const width = 300;
    const height = 100;
    const padding = 10;
    const chartWidth = width - padding * 2;
    const chartHeight = height - padding * 2;
    
    const points = data.map((d, i) => {
      const x = padding + (i / (data.length - 1 || 1)) * chartWidth;
      const y = height - padding - (d.value / maxValue) * chartHeight;
      return `${x},${y}`;
    }).join(' ');
    
    return (
      <div className="space-y-2">
        {title && <h4 className="text-sm font-medium text-neutral-400 mb-3">{title}</h4>}
        <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-24">
          {/* Grid lines */}
          {[0, 0.25, 0.5, 0.75, 1].map((pct) => (
            <line
              key={`grid-${pct}`}
              x1={padding}
              y1={height - padding - pct * chartHeight}
              x2={width - padding}
              y2={height - padding - pct * chartHeight}
              stroke="rgba(255,255,255,0.1)"
              strokeDasharray="4"
            />
          ))}
          {/* Line */}
          <polyline
            fill="none"
            stroke="#00F0FF"
            strokeWidth="2"
            points={points}
          />
          {/* Points */}
          {data.map((d, i) => {
            const x = padding + (i / (data.length - 1 || 1)) * chartWidth;
            const y = height - padding - (d.value / maxValue) * chartHeight;
            return (
              <circle
                key={d.label ?? `pt-${i}`}
                cx={x}
                cy={y}
                r="4"
                fill="#00F0FF"
                className="hover:r-6 transition-all"
              />
            );
          })}
        </svg>
        <div className="flex justify-between text-xs text-neutral-500">
          {data.map((d, i) => (
            <span key={d.label ?? `lbl-${i}`}>{d.label}</span>
          ))}
        </div>
      </div>
    );
  }
  
  return null;
}

export default AffiliateChart;
